import { useEffect, useState } from "react";
import NavBar from "../components/NavBar";
import Loader from "../components/Loader";

export default function DigiLayout({ children }) {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        // Loading function to load data or 
        // fake it using setTimeout;
        const loadData = async () => {

            const timer = setTimeout(() => {
                setLoading(false);
            }, 5000); // Set the delay time in milliseconds (e.g., 5000 for 5 seconds)

            return () => clearTimeout(timer); // Clean up the timer on component unmount

            
        };

        loadData();
    }, [])
    return (
        <>
            <div className="  px-[10px] xl:mx-auto max-w-screen-screenWidth min-h-screen bg-blue-950 ">
                {loading ?
                    <Loader /> :
                    <div>
                        <NavBar />
                        <div className="mt-5">
                            {children}
                        </div>
                    </div>}
            </div>
        </>
    )
}